import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Body from './Components/BodyComp/body';
import Footer from './Components/MainComp/footer';
import { NavComp } from './Components/MainComp/nav';
import ContactUs from './Components/ContactusComp/contactus';
import AboutUs from './Components/AboutComp/aboutus';
import Faq from './Components/FaqsComp/faq';
import Impact1 from './Components/SocialComp/school-eye-health';
import Impact2 from './Components/SocialComp/impact2';
import Impact3 from './Components/SocialComp/impact3';
import ScreeningRequest from './Components/BodyComp/screeningrequest';
import SupportMission from './Components/BodyComp/supportmission';
import BookanEyeTest from './Components/AboutComp/bookaneyetest';
import PrivacyAndPolicy from './Components/FaqsComp/privacyandpolicy';
import TermsAndConditions from './Components/FaqsComp/termsandconditions';
import JoinUs from './Components/BodyComp/joinus';
import SchoolVisit from './Components/SocialComp/schoolvisit';
import Bookaneyescreeningfordisabled from './Components/SocialComp/bookaneyescreeningfordisabled';
import AwarenessProgram from './Components/SocialComp/awarenessprogram';
import Gallery from './Components/GalleryComp/gallery';

import TeachersTraining from './Components/CommunityProgramComp/teachers-training';
import VolunteerProgram from './Components/CommunityProgramComp/volunteer-program';
import PhiTraining from './Components/CommunityProgramComp/phi-training';

import ScrollToTop from './ScrollComp/ScrollToTop';

import Popup from './Components/BodyComp/popup';

import VisualImpairedRegistration from './Components/BodyComp/visual-impaired-registration';

import SignIn from "./Components/LoginComp/signin";
import PrivateRoute from './Utils/PrivateRoute';
import AdminPanel from './Components/AdminComp/adminpanel';
import ForgotPassword from './Components/LoginComp/ForgotPassword';
import AdminPanelMoratuwa from './Components/AdminComp/adminpanelmoratuwa';


function App() {

  return (
    <Router>
         <ScrollToTop />
      <NavComp />
    
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/school-eye-health" element={<Impact1 />} />
        <Route path="/impact2" element={<Impact2 />} />
        <Route path="/impact3" element={<Impact3 />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/screeningrequest" element={<ScreeningRequest />} />
        <Route path="/supportmission" element={<SupportMission />} />
        <Route path="/bookaneyetest" element={<BookanEyeTest />} />
        <Route path='/termsandconditions' element={<TermsAndConditions />}/>
        <Route path='/privacyandpolicy' element={<PrivacyAndPolicy />} />
        <Route path='/joinus' element={<JoinUs />} />
        <Route path='/schoolvisit' element={<SchoolVisit />} />
        <Route path='/bookaneyescreeningfordisabled' element={<Bookaneyescreeningfordisabled />} />
        <Route path='/awarenessprogram' element={<AwarenessProgram />} />
        <Route path='/gallery' element={<Gallery />} />

        <Route path='/teachers-training' element={<TeachersTraining />} />
        <Route path='/volunteer-program' element={<VolunteerProgram />} />
        <Route path='/phi-training' element={<PhiTraining />} />
        <Route path='/visual-impaired-registration' element={<VisualImpairedRegistration />} />
        <Route path='Signin' element={<SignIn />} />
        <Route path='ForgotPassword' element={<ForgotPassword />}  />




                <Route
          path="/adminpanel"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        />


               <Route
          path="/adminpanelmoratuwa"
          element={
            <PrivateRoute>
              <AdminPanelMoratuwa />
            </PrivateRoute>
          }
        />




        </Routes>
          <Popup />
      <Footer />
    </Router>
  );
}

export default App;


